import React, { useState } from "react";
import toast from "react-hot-toast";
import HomeService from "../../../Services/HomeService";
import { useNavigate } from "react-router-dom";

const headLineStyle = {
    textAlign: "center",
    fontSize: "30px",
    color: "#868e96",
    margin: "15px",
    fontWeight: "bold",
};

function AddBhk() {
    const [bhk, setBhk] = useState("");
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        const data = {
            bhk: bhk,
        };
        try {
            const res = await HomeService.addBhk(data);
            if (res?.status) {
                toast.success("BHK added successfully!");
                clearAddForm();
                navigate("/manage-bhk");
            }
        } catch (error) {
            toast.error("Failed to add BHK.");
            console.error("Error adding BHK:", error);
        }
    };

    const clearAddForm = () => {
        setBhk("");
    };

    return (
        <div className="main_wrap" style={{ marginTop: "6rem" }}>
            <div className="container-fluid">

                <div className="mt-5">
                    <div style={headLineStyle} className="page-headline">
                        Add BHK
                    </div>
                    <hr />

                    <section className="chartBox_area">

                        <form onSubmit={handleSubmit}>
                            <div className="row">
                                <div className="col-md-6 mt-3">
                                    <label htmlFor="bhk">
                                        BHK<span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        id="bhk"
                                        className="form-control"
                                        value={bhk}
                                        onChange={(e) => setBhk(e.target.value)}
                                        placeholder="Enter BHK"
                                        required
                                    />
                                </div>
                            </div>
                            <button
                                type="submit"
                                className="btn btn-primary mt-3"
                            >
                                Add BHK
                            </button>
                        </form>
                    </section>
                </div>
            </div>
        </div>
    );
}

export default AddBhk;